<template>
  <span>
  <span v-if="object.status != 2">
  <router-link
      :title="$t('edit')"
      v-b-tooltip.hover
      class="data-table-action"
      :to="{name: 'PatientVisitPage', params: { visitid: object.id, id: object.client_id, page: 'teeth' } }">
    <EditSvg class="svg-stroke-light"/><span class="action-button-mob-title">{{ $t('edit') }}</span>
  </router-link>
    </span>
    <span v-if="canCancel">
      <a class="data-table-action"
         :title="$t('cancel_verb')"
         v-b-tooltip.hover
         @click="cancelRecord">
      <DeleteSvg class="svg-stroke-light"/>
    </a>
    </span>
    </span>
</template>

<script setup>

import EditSvg from '@/assets/svg-vue/general/edit2.svg'
import DeleteSvg from "@/assets/svg-vue/general/delete2.svg.vue"
import {CalendarService} from "@/services/api/calendar.api.service"
import {computed, getCurrentInstance, inject, onBeforeMount} from "vue"
import {useStore} from "vuex"
import moment from "moment/moment"

const props = defineProps({
  object: {
    type: Object
  }
})

let noty = null
let i18n = null

const store = useStore()

const showReasonPrompt = inject('showReasonPrompt')

const clinic = computed(() => store.state.auth.clinic)
const rights = computed(() => store.state.auth.rights)
const additional = computed(() => clinic.value.clinic_additional)
const isTreatment = computed(() => props.obvject?.record_type !== 'block')
const canBeEdited = computed(() => {
  if(props.object.start === moment().format('YYYY-MM-DD') && rights.value.includes('records_during_day')) {
    return true
  }
  return !(props.object.hasPassed && !rights.value.includes('edit_history'))
})
const canCancel = computed(() => {
  return isTreatment.value
      && canBeEdited.value
      && props.object.status !== 2
      && Number(props.object.is_paid) !== 1
      && rights.value.includes('add_records')
      && rights.value.includes('recording_status')
})

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  noty = instance?.appContext?.app?.noty
  i18n = instance?.ctx?.$i18n
})

const cancelRecord = async () => {
  let reason = ''
  if(additional.value.ask_reason_cancel) {
    reason = await showReasonPrompt()
    if(!reason) return
  }
  CalendarService.cancelRecord(props.object.id, reason).then(() => {
    noty.info(i18n.t('success_message'))
    store.commit('incrementDataTableCounter')
  }).catch((e) => {
    console.log(e)
  })
}
</script>
